<template>
  <b-row>
    <b-col cols="12">
      <holiday-add-form />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import HolidayAddForm from './HolidayAddForm.vue'

export default {
  components: {
    BRow,
    BCol,
    HolidayAddForm,
  },
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-wizard.scss';
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
